exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./~/sass-loader!./client/app/app.scss
 ** module id = 57
 ** module chunks = 0
 **/